import breakpoints from '../../../breakpoints.json'

class Popover {
    constructor(element) {
        this.element = element
        this.observeSize()
        this.forceClose()
    }

    get from () {
        return breakpoints[this.element.getAttribute('data-popover-from')] ?? 0
    }

    get until() {
        return breakpoints[this.element.getAttribute('data-popover-until')] ?? Infinity
    }

    get matches() {
        const min = '(min-width: ' + this.from + 'px)'
        const max = isFinite(this.until) ? '(max-width: ' + this.until + 'px)' : ''

        return window.matchMedia(min + (max ? ' and ' + max : '')).matches
    }

    observeSize() {
        const observer = new ResizeObserver(this.handleResize.bind(this))

        observer.observe(document.documentElement)
    }

    // Necessary for Safari
    forceClose() {
        this.element.querySelector('button[popovertargetaction="hide"]').addEventListener('click', () => {
            if (this.element.hasAttribute('popover')) {
                this.element.removeAttribute('popover')
            }
        })
    }

    handleResize() {
        if (this.matches) {
            this.element.setAttribute('popover', '')
        } else {
            this.element.removeAttribute('popover')
        }
    }
}

export default Popover
